import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import Card from "../../../components/Card";
import { Link, useNavigate } from "react-router-dom";
import ProfileHeader from "../../../components/profile-header";

// images
import gi1 from "../../../assets/images/page-img/gi-1.jpg";
import gi2 from "../../../assets/images/page-img/gi-2.jpg";
import gi3 from "../../../assets/images/page-img/gi-3.jpg";
import gi4 from "../../../assets/images/page-img/gi-4.jpg";
import gi5 from "../../../assets/images/page-img/gi-5.jpg";
import gi6 from "../../../assets/images/page-img/gi-6.jpg";
import gi7 from "../../../assets/images/page-img/gi-7.jpg";
import gi8 from "../../../assets/images/page-img/gi-8.jpg";
import gi9 from "../../../assets/images/page-img/gi-9.jpg";
import user05 from "../../../assets/images/user/05.jpg";
import user06 from "../../../assets/images/user/06.jpg";
import user07 from "../../../assets/images/user/07.jpg";
import user08 from "../../../assets/images/user/08.jpg";
import user09 from "../../../assets/images/user/09.jpg";
import user10 from "../../../assets/images/user/10.jpg";
import img1 from "../../../assets/images/page-img/profile-bg1.jpg";
import img2 from "../../../assets/images/page-img/profile-bg2.jpg";
import img3 from "../../../assets/images/page-img/profile-bg3.jpg";
import img4 from "../../../assets/images/page-img/profile-bg4.jpg";
import img5 from "../../../assets/images/page-img/profile-bg5.jpg";
import img6 from "../../../assets/images/page-img/profile-bg6.jpg";
import img7 from "../../../assets/images/page-img/profile-bg7.jpg";
import img9 from "../../../assets/images/page-img/profile-bg9.jpg";
import CreateGroupModal from "../../../components/CreateGroupModal";

const Groups = () => {
  const [showModal, setShowModal] = useState(false);
  const [groups, setGroups] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const storedGroups = JSON.parse(localStorage.getItem("groups")) || [];
    setGroups(storedGroups);
  }, []);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleSaveGroup = (newGroup) => {
    const updatedGroups = [...groups, { ...newGroup, id: Date.now() }];
    setGroups(updatedGroups);
    localStorage.setItem("groups", JSON.stringify(updatedGroups));
  };

  const handleGroupAction = (group) => {
    const params = new URLSearchParams({
      name: group.name,
      image: group.image,
      bgImage: group.bgImage
    });
    navigate(`/dashboards/app/group-detail?${params.toString()}`);
  };

  const hpeGroups = [
    {
      id: 1,
      name: "HPE ProLiant Servers",
      image: "https://www.insight.com/content/insight-web/en_US/shop/partner/hewlett-packard-enterprise/product-portfolio/servers/jcr%3Acontent/top-inner-full-width/column_layout/-column-1/image_0.img.jpg/1566699651505.jpg",
      bgImage: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDtOrQ6XGbm_SzTy_jI--kIRCZqse63jsEsw&s",
      posts: 156,
      members: 1200,
    },

    {
      id: 2,
      name: "HPE Storage Solutions",
      image: "https://www.expresscomputersystems.com/cdn/shop/collections/hpe_13-2_1600x.jpg?v=1612481384",
      bgImage: "https://selectium.com/wp-content/uploads/2022/09/HPE_data_satin_06_1920x1080-1200x480.jpg",
      posts: 210,
      members: 1500,
    },
    {
      id: 3,
      name: "HPE GreenLake",
      image: "https://media.licdn.com/dms/image/D4D12AQGWxelkJ9pyyQ/article-cover_image-shrink_720_1280/0/1656457214079?e=2147483647&v=beta&t=Kl5mz33pGVVVU5HmJRYpvBERGkYGb59uGXPKcZ-p6W8",
      bgImage: "https://www.servethehome.com/wp-content/uploads/2019/06/HPE-GreenLake-logo.jpg",
      posts: 178,
      members: 980,
    },
    {
      id: 4,
      name: "HPE Aruba Networking",
      image: "https://www.routehub.net/wp-content/uploads/2019/07/course_hpe3-420x420.png",
      bgImage: "https://avantiglobalresources.com/wp-content/uploads/2017/07/hpe-networking-and-storage.jpg",
      posts: 132,
      members: 870,
    },
  ];

  return (
    <>
      <ProfileHeader
        img="https://templates.iqonic.design/socialv-dist/react/static/media/profile-bg7.b5a8ff618b95e2b56a31.jpg"
        title="HPE Enterprise Groups"
      />
      <div id="content-page" className="content-inner">
        <Container>
          <Button variant="primary" onClick={handleShowModal} className="mb-3">
            Create Group
          </Button>
          <div className="d-grid gap-3 d-grid-template-1fr-19 items-center" style={{paddingBottom: '100px'}}>
            {hpeGroups.map((group) => (
              <Card key={group.id} className="group-box mb-0">
                <div className="top-bg-image">
                  <img src={group.bgImage} className="img-fluid w-100 o" alt="group-bg" />
                </div>
                <Card.Body className="text-center">
                  <div className="group-icon">
                    <img
                      src={group.image}
                      alt="profile-img"
                      className="rounded-7 img-fluid avatar-90 w-[100px] h-[100px] object-fit-cover"
                      style={{objectFit: 'cover', width: '180px', height: '130px', borderRadius: '10px'}}
                    />
                  </div>
                  <div className="group-info mt-3 mb-2">
                    <Link onClick={() => handleGroupAction(group)} className="h4">
                      {group.name}
                    </Link>
                  </div>
                  <div className="group-details pb-4 mb-4 border-bottom">
                    <ul className="d-flex align-items-center justify-content-center list-inline m-0 p-0 gap-3">
                      <li>
                        <div className="d-flex align-items-center gap-1">
                          <span className="material-symbols-outlined font-size-18">
                            description
                          </span>
                          <span className="text-capitalize">{group.posts} posts</span>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-1">
                          <span className="material-symbols-outlined font-size-18">
                            group
                          </span>
                          <span className="text-capitalize">Members {group.members}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="group-member mb-4">
                    <div className="iq-media-group">
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary-subtle fw-semibold px-3"
                    onClick={() => handleGroupAction(group)}
                  >
                    Join Group
                  </button>
                </Card.Body>
              </Card>
            ))}
          </div>
        </Container>
      </div>
      <CreateGroupModal
        show={showModal}
        handleClose={handleCloseModal}
        handleSave={handleSaveGroup}
      />
    </>
  );
};

export default Groups;